import type { FormFieldsData } from 'framework/form';
import { CreateEditFormDrawer } from 'framework/ViewTypes/contentLayout';
import type { PositionSlotListItem } from 'domain/shared/positionSlot';
import useCreatePositionFillRequestService from '../createPositionFillRequest';
import { getCreatePositionFillRequestSections } from './createPositionFillRequestSections';
import createPositionFillRequestValidation from './createPositionFillRequestValidation';
import type { PositionFillRequestFormValues } from '../types';

type CreatePositionFillRequestDrawerProps = {
  isOpen: boolean;
  positionSlot: PositionSlotListItem;
  onClose: () => void;
  onCreated?: () => void;
};

const buildInitialValues = (positionSlot: PositionSlotListItem): PositionFillRequestFormValues => ({
  positionSlotId: positionSlot.id,
  matchingPositionSlotIds: [],
  expirationPeriodInMonth: '',
  responsibilities: '',
  requiredExperience: '',
  englishLevel: 'B1',
  requirements: '',
});

const CreatePositionFillRequestDrawer = ({
  isOpen,
  positionSlot,
  onClose,
  onCreated,
}: CreatePositionFillRequestDrawerProps) => {
  const { createPositionFillRequest } = useCreatePositionFillRequestService();

  const submitForm = (values: FormFieldsData) => createPositionFillRequest(values as PositionFillRequestFormValues);

  return (
    <CreateEditFormDrawer
      key={positionSlot.id}
      isOpen={isOpen}
      onClose={onClose}
      title="Send position fill request"
      header="Submit a request to start the hiring process for the position."
      width={820}
      initialData={buildInitialValues(positionSlot)}
      submitFormFunc={submitForm}
      submitButtonTitle="Send"
      getValidationSchemaFunc={() => Promise.resolve(createPositionFillRequestValidation)}
      handleDirty={false}
      afterSubmit={{
        execute: () => {
          onCreated?.();
          onClose();
        },
        message: 'Position fill request has been sent.',
      }}
      getSections={() => getCreatePositionFillRequestSections(positionSlot)}
    />
  );
};

export default CreatePositionFillRequestDrawer;
